import React from 'react';

//components
import Container from 'components/Container';
import SanityImage from 'components/SanityImage';

//types
import type {
  SanityModuleGridSection,
  SanityImageTitleDescriptionBlock,
} from 'domains/modules';

interface Props {
  module: SanityModuleGridSection;
}

export default function GridSection({module}: Props) {
  return (
    <section className="module--grid-section py-4 md:py-6">
      <header className="col-span-12 mb-4 text-center md:mb-6">
        <h2 className="text-xl md:text-section font-bold uppercase tracking-wide">
          {module.section_title}
        </h2>
      </header>
      <Container>
        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {module.blocks &&
            module.blocks.map((b) => {
              return <ImageTitleDescriptionBlock key={b._key} block={b} />;
            })}
        </div>
      </Container>
    </section>
  );
}

const ImageTitleDescriptionBlock: React.FC<{
  block: SanityImageTitleDescriptionBlock;
}> = ({block}) => {
  return (
    <article className="col-span-12 md:col-span-4 text-center">
      <div className="aspect-w-16 aspect-h-9 relative mx-auto mb-3 w-2/5 max-w-[130px] md:w-1/2">
        <SanityImage
          layout="fill"
          objectFit="contain"
          sizes={['50vw, 100vw']}
          src={block.image?.asset._ref}
          alt={block.title ?? ''}
          loading="lazy"
        />
      </div>
      <h5 className="mb-2 text-md font-semibold md:text-[20px] md:leading-[30px]">
        {block.title}
      </h5>
      <p className="mx-auto max-w-xs text-md font-normal !leading-relaxed text-slate-600">
        {block.description}
      </p>
    </article>
  );
};
